import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-merge-history',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './merge-history.component.html',
  styleUrl: './merge-history.component.scss',
})
export class MergeHistoryComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  statusCodes: any[] = [
    { id: 2, status: 'DA Approved' },
    { id: 3, status: 'DA Rejected' },
    { id: 4, status: 'SU Approved' },
    { id: 5, status: 'SU Rejected' },
    { id: 1, status: 'FC Pending For Review' },
  ];
  ngOnInit() {
    console.log(this.data, 'merge history');
    let list = this.data.forEach((item: { fcDetails: any[] }) => {
      item.fcDetails.map((fc) => {
        this.statusCodes.forEach((sc) => {
          if (sc.id === fc.status) fc.currentStatus = sc.status;
        });
      });
    });
  }
}
